import React from 'react';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const PartnersWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.status} className="mydesk-group"><strong>{g.count}</strong> {g.label}</span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>No partners to show.</WidgetEmpty>}
      {items.map((p) => (
        <WidgetRow
          key={p.id}
          icon={faAddressBook}
          tone="brand"
          title={p.name}
          subtitle={p.numbers}
          right={(
            <>
              <Pill tone={p.status_tone || 'neutral'}>{p.status_label}</Pill>
              <Age>{p.age_label}</Age>
            </>
          )}
          onClick={() => goTo(p.url)}
        />
      ))}
      <WidgetFooter label="Open CRM" url={data.url} />
    </>
  );
};

export default PartnersWidget;
